module.exports = __webpack_public_path__ + "img/none-img.435ea044.png";